import LocalStorageService from './local-storage-service';

export default class AuthService {
  public static getAuthToken(): string | null {
    return LocalStorageService.getAuthToken();
  }

  public static setAuthToken(authToken: string): void {
    LocalStorageService.setAuthToken(authToken);
  }

  public static getDeviceId(): string | null {
    return LocalStorageService.getDeviceId();
  }

  public static setDeviceId(deviceId: string): void {
    LocalStorageService.setDeviceId(deviceId);
  }

  public static deleteAuthToken(): void {
    return LocalStorageService.deleteAuthToken();
  }
}
